import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { WebhookInitials, GetWebhookResponse, CreateWebhookRequest, ReplaceWebhookRequest } from './_webhookTypes';
import axios from "axios";
import { handleAxiosError } from '../../axios/handleAxiosError';
import { handleError } from '../../utils/handleError';
import { buildApiUrl } from '../../axios/urlCreator';

const initialState: WebhookInitials = {
    webhook: null,
    loading: false,
    error: null
};

const webhookSlice = createSlice({
    name: 'webhook',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET Webhook
            .addCase(getWebhooks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getWebhooks.fulfilled, (state, action) => {
                state.loading = false;
                state.webhook = action.payload;
                state.error = null;
            })
            .addCase(getWebhooks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // POST (Create) Webhook
            .addCase(createWebhook.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createWebhook.fulfilled, (state, action) => {
                state.loading = false;
                state.webhook = action.payload;
                state.error = null;
            })
            .addCase(createWebhook.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // PUT (Update) Webhook
            .addCase(updateWebhook.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateWebhook.fulfilled, (state, action) => {
                state.loading = false;
                state.webhook = action.payload;
                state.error = null;
            })
            .addCase(updateWebhook.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

// GET Webhook
export const getWebhooks = createAsyncThunk<GetWebhookResponse, void>(
    'webhooks/getWebhook',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get<GetWebhookResponse>(buildApiUrl("webhooks"));
            return response.data;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(handleAxiosError(error));
            }
            return rejectWithValue(handleError(error));
        }
    }
);

// POST (Create) Webhook
export const createWebhook = createAsyncThunk<GetWebhookResponse, CreateWebhookRequest>(
    'webhooks/createWebhook',
    async (createWebhookRequest, { rejectWithValue }) => {
        try {
            const response = await axios.post<GetWebhookResponse>(buildApiUrl("webhooks"), createWebhookRequest);
            return response.data;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(handleAxiosError(error));
            }
            return rejectWithValue(handleError(error));
        }
    }
);

// PUT (Update) Webhook
export const updateWebhook = createAsyncThunk<GetWebhookResponse, ReplaceWebhookRequest>(
    'webhooks/updateWebhook',
    async (replaceWebhookRequest, { rejectWithValue }) => {
        try {
            const response = await axios.put<GetWebhookResponse>(buildApiUrl("webhooks"), replaceWebhookRequest);
            return response.data;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(handleAxiosError(error));
            }
            return rejectWithValue(handleError(error));
        }
    }
);


export const { } = webhookSlice.actions;
export default webhookSlice.reducer;
